import { CSSProgressiveBody03Medium } from "@caisy/league";
import styled from "styled-components";

export const SUpgradeProjectWarningModalDescription = styled.p`
  ${CSSProgressiveBody03Medium};
  color: var(--text-04);
  text-align: center;
`;
